import { fetchFromAPI } from 'utils/api';

export function getDiagnoses(params) {
  return fetchFromAPI('/diagnoses', { params });
}
